import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";
import { MentorProfileData } from "api/getUserProfile";

type Params = {
	uid: string;
	timezone: string;
	displayName: string;
	locationDistrict?: string;
	locationCountryCode?: string;
	mentorProfileAboutMe?: string;
	terms?: MentorProfileData["terms"];
	defaultCurrencyCode?: string;
	skypeId?: string;
	defaultGoogleMeetLink?: string;
	hasPaidZoomAccount?: boolean;

	paymentProvidersMBWay?: string;
	paymentProvidersWisetag?: string;
	paymentProvidersCustom?: string;
};

export const saveAccountSettings = makeSubmitData<Params>(
	"saveAccountSettings"
);
